import { useState } from "react";
import ElementLabel from './ElementLabel';

const NewOptionValue = ({ index, title, close, inputData, setInputData }) => {

    // Gestisco l'input di un nuovo value
    const [valueInput, setValueInput] = useState(null);
    const handleValueInput = (event) => {
        setValueInput(event.target.value)
    };

    // Gestisco aggiunta o eliminazione di un valore
    const handleChangeValue = (titleForRemove) => {
        let oldValueList = [...inputData.customOptions[index].values];
        let newValueList;
        if (typeof titleForRemove === 'string') {
            // Remove
            newValueList = oldValueList.filter(element => element !== titleForRemove);
        } else {
            // Add
            newValueList = [...oldValueList, valueInput]
        }
        let newCustomOptions = inputData.customOptions.map(option => {
            if(option.title === title) {
                return { ...option, values: newValueList}
            }
            return option
        })
        setInputData(prevState => ({
            ...prevState,
            customOptions: newCustomOptions
        }))
        setValueInput(null);
    }

    return (
        <div className="flex flex-col p-2 gap-2 w-full lg:w-fit">
            <div className="flex gap-2">
                <div className="mt-2" onClick={() => close(title)}><i className="fi fi-sr-circle-xmark text-xl cursor-pointer"></i></div>
                <label htmlFor="description" className="text-3xl underline">{title}</label>
            </div>
            <div className="flex gap-2 max-w-[800px] lg:w-[800px]">
                <input type="text" className="flex-grow" onChange={handleValueInput} value={valueInput ? valueInput : ''} />
                {valueInput && <button className="w-[72px] h-[72px] rounded-lg border-2 border-[#225424] text-[#225424] flex justify-center items-center text-4xl pb-1" onClick={handleChangeValue}>+</button>}
                {!valueInput && <button className="w-[72px] h-[72px] rounded-lg border-2 border-neutral-300 text-neutral-300 flex justify-center items-center text-4xl pb-1 cursor-not-allowed">+</button>}
            </div>
            <div className="border-2 p-2 flex flex-col gap-2 min-h-[72px] rounded">
                {
                    inputData.customOptions.length > 0 &&
                    inputData.customOptions[index].values &&
                    inputData.customOptions[index].values.length > 0 &&
                    inputData.customOptions[index].values.map((element, index) => {
                        return <ElementLabel key={index} string={element} close={handleChangeValue} />
                    })
                }
            </div>
        </div>
    )
}

export default NewOptionValue;